<template>
  <div>
      <ReceiptsMaster addNew="/finance/sales-receipt/" type="SALES"></ReceiptsMaster>
  </div>
</template>

<script>
import ReceiptsMaster from './master.vue'
export default {
  components: { ReceiptsMaster }
}
</script>

<style>

</style>